import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminShell from './Components/AdminShell';
import OutreachThemeProvider from './Components/OutreachThemeProvider';
import PrivacyPolicyPage from './pages/privacy-policy';
import { captureAttributionFromLocation } from './utils/attributionPersistence';

export const PublicLayout = () => {
  const location = useLocation();

  useEffect(() => {
    captureAttributionFromLocation(location, document);
  }, [location]);

  return <Outlet />;
};

const AdminLayout = () => {
  const location = useLocation();

  if (location.pathname === '/privacy-policy') {
    return <PrivacyPolicyPage />;
  }

  return (
    <OutreachThemeProvider>
      <AdminShell />
    </OutreachThemeProvider>
  );
};

export default AdminLayout;

// UI-003C trust-domain layout aliases.
// These are architectural names for route ownership, not new runtime boundaries:
// each alias resolves to the exact same layout implementation used today.
export const StaffLayout = AdminLayout;
export const AlumLayout = AdminLayout;
export const TokenOperationalLayout = PublicLayout;
export const KioskOperationalLayout = PublicLayout;

export const StaffKioskLayout = () => (
  <OutreachThemeProvider>
    <Outlet />
  </OutreachThemeProvider>
);
